module.exports = __webpack_public_path__ + "static/media/CONSOLIDADO_CRS.cc7b8ed5.pdf";